import {get, isEmpty, isNil, isNumber} from "lodash"
import {parseIfNumeric} from "helpers/number"

export const getSubItemLength = (subItem) => {
  if (subItem.length)
    return subItem.length

  if (subItem.content)
    return subItem.content.sizeX

  return subItem.part
      ? subItem.part.sizeX
      : ''
}

export const getSubItemWidth = (subItem) => {
  if (subItem.width)
    return subItem.width

  if (subItem.content)
    return subItem.content.sizeY

  return subItem.part
      ? subItem.part.sizeY
      : ''
}

export const getSubItemHeight = (subItem) => {
  if (subItem.height)
    return subItem.height

  if (subItem.content)
    return subItem.content.sizeZ

  return subItem.part
      ? subItem.part.sizeZ
      : ''
}

export const sortQuickAddOrPriceListTemplateItems = (a, b) => {
  if (get(a,'templateItem',null) === get(b,'templateItem',null)) {
    return 0
  }

  if (get(a,'templateItem',null) === null || isNil(get(a,'templateItem',null)) ) {
    return 1
  }
  if (get(b,'templateItem',null) === null || isNil(get(b,'templateItem',null))) {
    return -1
  }
}

export const isSavedSubItem = (subItem) =>
  isNumber(parseIfNumeric(get(subItem, 'id'))) && !get(subItem, 'isNew')

/**
 * Ids of sub-items that were deleted by being flagged in place.
 * Only ever reports rows the server already knows about.
 *
 * @param {Array} subItems - Sub-items at one level
 * @returns {Array} Ids to delete
 */
export const getFlaggedDeletedSubItemIds = (subItems) => {
  if (isEmpty(subItems)) return []

  return subItems
    .filter(item => isSavedSubItem(item) &&
      (get(item, 'deleted') || (!get(item, 'enabled') && get(item, 'type'))))
    .map(item => get(item, 'id'))
}

/**
 * Every deletion that applies to one item's children.
 *
 * A sub-item is deleted either by being flagged in place, or by a drawer having
 * already dropped it from the tree and recorded its id in deletedSubItems. The
 * Pricing Calculator does the latter: its sub-items are re-priced and replaced
 * after an edit.
 */
export const getDeletedSubItemIdsForItem = (item) => {
  const subItems = get(item, 'subItems')
  const recorded = get(item, 'deletedSubItems') || []

  const deleted = [...new Set([...recorded, ...getFlaggedDeletedSubItemIds(subItems)])]

  if (isNil(subItems) && isEmpty(deleted)) return null

  return deleted
}
